/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessengerSettings {
    'use strict';
    import IMeevoMessengerQuickAnswer = Meevo.Model.IMeevoMessengerQuickAnswer;

    class QuickResponsesContoller {
        static $inject = ['meevo.components.modal.ModalService'];

        public responses: IMeevoMessengerQuickAnswer[];
        public isShowAddingForm: boolean;
        public charLimit: number;
        public isFromArrivals: boolean;

        constructor(private modalService: Meevo.Components.Modal.IModalService) {}        

        /**
         * Returned the array of Qb Error 
         * @param {any} logItem
         * @returns {string[]}
         */
        showQuickResponseEditForm(): void {
            if (this.responses.length >= 20) {
                this.modalService.alert('MESSAGE_MAXIMUM_QUICK_RESPONSES');
                return;
            }

            const orderNumber: number =
                this.responses && this.responses.length ? Math.max.apply(null, _.pluck(this.responses, 'orderNumber')) + 1: 0;                
            this.responses.push(this.getDefaultRepsonse(orderNumber));
        }

        /**
         * Change the order number of the response by 
         * @param {number} index
         * @param {boolean} isHoistAnswer
         */
        changeOrderNumber(index: number, isHoistAnswer: boolean): void {
            if (index === 0 && isHoistAnswer || index >= this.responses.length && !isHoistAnswer) return;

            const indexOfNextElement: number = isHoistAnswer ? index - 1 : index + 1,
                responses = angular.copy(this.responses);

            // Swap data ;)
            [responses[index].orderNumber, responses[indexOfNextElement].orderNumber] = [responses[indexOfNextElement].orderNumber, responses[index].orderNumber];
            [responses[index], responses[indexOfNextElement]] = [responses[indexOfNextElement], responses[index]];
            this.responses = responses;
        }

        /**
         * Delete quich response from the array
         * @param {number} index
         */
        deleteQuickResponse(index: number): void {
            if ( (this.isFromArrivals && (index != 0 && index != 1)) || !this.isFromArrivals) {
                this.responses.splice(index, 1);
            }
        }

        /**
         * Returned default object of the response
         * @param {number} orderNumber
         * @returns {ITextelQuickAnswer}
         */
        private getDefaultRepsonse(orderNumber: number = null): IMeevoMessengerQuickAnswer {
            return {
                displayName: '',
                body: '',
                orderNumber
            };
        }
    }

    class QuickResponsesComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/meevoMessengerSettings/components/quickResponses/quickReponses.template.html';
        controller = QuickResponsesContoller;
        controllerAs = 'quickResp';
        bindings: any = {
            responses: '=',
            isShowAddingForm: '=',
            charLimit: '<?',
            isFromArrivals: '<'
        };
    }

    angular.module('meevo.plugins.meevoMessengerSettings')
        .component('meevoMessengerSettingsQuickResponses', new QuickResponsesComponent());

}

